import { Pipe, PipeTransform ,Injectable } from '@angular/core';

@Pipe({
  name: 'ngforFilter'
})

@Injectable()

export class FilterPipe implements PipeTransform {

  transform(data?: any, name?: any,value?:any): any {
    let filterd_result=[];
    if(data){
    data.forEach(element => {
      if(element[name]==value){
        filterd_result.push(element);
      }
      if(value=='all'){
        filterd_result.push(element);

      }

    });
}
    return filterd_result; 
  }

}


// WEBPACK FOOTER //
// D:/xampp/htdocs/playitadmin_frontend/src/app/pipes/filter.pipe.ts